import { render, staticRenderFns } from "./PrincipaliDocumenti_Tab3.vue?vue&type=template&id=5305329a&scoped=true&"
import script from "./PrincipaliDocumenti_Tab3.vue?vue&type=script&lang=js&"
export * from "./PrincipaliDocumenti_Tab3.vue?vue&type=script&lang=js&"
import style0 from "./PrincipaliDocumenti_Tab3.vue?vue&type=style&index=0&id=5305329a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305329a",
  null
  
)

export default component.exports